import PropTypes from "prop-types";
// material
import { Box, Popover, Slide } from "@mui/material";
import { alpha, styled } from "@mui/material/styles";
import { useRef } from "react";

MenuPopover.propTypes = {
  children: PropTypes.node.isRequired,
  sx: PropTypes.object,
  checked: PropTypes.bool,
};

export default function MenuPopover({ children, sx, checked, ...other }) {
  return (
    <Popover
      disableScrollLock
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      transformOrigin={{ vertical: "top", horizontal: "right" }}
      PaperProps={{
        sx: {
          p: 1,
          width: 200,
          overflow: "inherit",
          backdropFilter: "blur(7px)",
          WebkitBackdropFilter: "blur(7px)", // Fix on Mobile
          backgroundColor: (theme) =>
            alpha(theme.palette.background.paper, 0.6),

          ...sx,
        },
      }}
      {...other}
    >
      {children}
    </Popover>
  );
}
